import React from 'react';
import { bool, string } from 'prop-types';
import { useSelector } from 'react-redux';
import NamedLink from '../../NamedLink/NamedLink';
import IconCart from '../../IconCart/IconCart';

import css from './CartIcon.module.css';
import classNames from 'classnames';

const CartIcon = ({ currentUserHasListings, rootClassName, className }) => {
    const { cartItems } = useSelector(state => state.cart);
    const classes = classNames(rootClassName || css.hoverEffect, className);
    return (
        <div className={classes}>
            <NamedLink
                className={css.cartIcon}
                name="CartPage"
                params={{ tab: currentUserHasListings ? 'sales' : 'orders' }}
            >
                <IconCart />
                <span className={css.cartNb}>{cartItems?.length || 0}</span>
            </NamedLink>
        </div>
    )
}

CartIcon.defaultProps = {
    rootClassName: null,
    className: null,
};

CartIcon.propTypes = {
    rootClassName: string,
    className: string,
    currentUserHasListings: bool,
};


export default CartIcon;
